/*=========================================================================================
  File Name: module-usertax.js
  Description: UserTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-ava-report-state';
import mutations from './module-ava-report-mutations';
import actions from './module-ava-report-actions';
import getters from './module-ava-report-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
